module.exports = __webpack_public_path__ + "media/images/product/m_d-89e3ed213144e71c2c0bb00d7cf840ab.png";